import Chip from '@material-ui/core/Chip';

import PropTypes from 'prop-types';

import { STATUS_COLORS, STATUS_LABELS } from '../constants';

export default function StatusChip({ status, size = 'small', style = {} }) {
  const statusConfig = STATUS_COLORS[status] || { bg: '#f5f5f5', text: '#666' };
  const label = STATUS_LABELS[status] || status;

  return (
    <Chip
      label={label}
      size={size}
      style={{
        backgroundColor: statusConfig.bg,
        color: statusConfig.text,
        fontWeight: 600,
        ...style,
      }}
    />
  );
}

StatusChip.propTypes = {
  status: PropTypes.string.isRequired,
  size: PropTypes.oneOf(['small', 'medium']),
  style: PropTypes.object,
};
